import { forwardRef } from 'react';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import { Orientation } from './enums';
import css from './style.module.css';
import { clsx } from '@team/clsx';

const orientationPresets: Record<Orientation, string> = {
  [Orientation.HORIZONTAL]: css.horizontal,
  [Orientation.VERTICAL]: css.vertical,
};

export const Layout = forwardRef<HTMLHRElement, Props>(function Component(
  { orientation = Orientation.HORIZONTAL, ...props },
  forwardedRef
) {
  const ariaOrientation = orientation === 'vertical' ? orientation : undefined;

  return (
    <RootComponent
      {...props}
      Component="div"
      baseClassName={clsx(css.root, orientationPresets[orientation])}
      role="separator"
      aria-orientation={ariaOrientation}
      ref={forwardedRef}
    >
      <div className={css.line} />
    </RootComponent>
  );
});
